import React from "react";
import DataTableBase from "./dataTableBase";
import { LNSColumns } from "./columnDefs";

export default function LNSTable({ lnss = [] }) {
  return (
    <DataTableBase
      title={"LNS's"}
      data={lnss}
      columns={LNSColumns}
      orderby="time_updated"
    />
  );
}
